function extraSiblings(className = undefined) {
  let parent = this.parent(),
    siblingsAndSelf;
  if (className) {
    siblingsAndSelf = parent[0].querySelectorAll(className);
  }
  else {
    siblingsAndSelf = parent[0].children;
  }
  let self = this[0],
    siblingsAndSelfArr = [].slice.call(siblingsAndSelf),
    siblings = siblingsAndSelfArr.filter(function (elem) {
        if (elem !== self) {
          return angular.element(elem);
        }
      }
    );
  return siblings;
}

function findPos() {
  let left = 0,
    top = 0,
    obj = this[0];
  if (obj.offsetParent) {
    do {
      left += obj.offsetLeft;
      top += obj.offsetTop;
      obj = obj.offsetParent;
    } while (obj);
  }
  return {left, top};
}

function init() {
  //Extra methods
  let extra = {
    extraSiblings,
    findPos
  };
  Object.assign(angular.element.prototype, extra);
}

export default {
  init: init
};



/** WEBPACK FOOTER **
 ** ./src/app/shared/jqLiteExtras.js
 **/